// src/utils/formatDate.js

/**
 * Formats a date string or timestamp into a readable format
 * @param {string|number} dateInput - Date string, ISO string, or timestamp
 * @param {Object} options - Formatting options
 * @returns {string} Formatted date string
 */
export function formatDate(dateInput, options = {}) {
    if (!dateInput) return 'N/A';

    let date;
    // Date-only strings (YYYY-MM-DD) are parsed as UTC by new Date(),
    // which shifts to the previous day in western timezones. Parse as local instead.
    if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
      const [year, month, day] = dateInput.split('-');
      date = new Date(Number(year), Number(month) - 1, Number(day));
    } else if (typeof dateInput === 'number' && dateInput > 0 && dateInput < 1e12) {
      // Seconds-based timestamp — convert to milliseconds
      date = new Date(dateInput * 1000);
    } else {
      date = new Date(dateInput);
    }

    // Check if date is valid
    if (isNaN(date.getTime())) return 'Invalid date';
    
    const defaultOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: options.includeTime ? '2-digit' : undefined,
      minute: options.includeTime ? '2-digit' : undefined,
    };
    
    return date.toLocaleDateString('en-US', {
      ...defaultOptions,
      ...options
    });
  }